import { useState } from 'react';
import { Menu } from 'lucide-react';
import Sidebar from './Sidebar';

const Layout = ({ children, title, action }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen bg-cream">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        <div className="border-b border-border bg-surface px-4 md:px-8 py-4 flex justify-between items-center gap-3">
          <button
            type="button"
            data-testid="sidebar-toggle"
            onClick={() => setSidebarOpen(true)}
            className="md:hidden text-text-secondary hover:text-maroon shrink-0"
            aria-label="Open menu"
          >
            <Menu className="w-6 h-6" strokeWidth={1.5} />
          </button>
          <h1 data-testid="layout-title" className="font-heading text-xl md:text-3xl font-bold text-text-primary tracking-tight truncate">{title}</h1>
          {action && <div className="shrink-0">{action}</div>}
        </div>
        <div className="flex-1 overflow-auto">
          <div className="p-4 md:p-8">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
